import svgs from '../svgs';

const sponsorsCarousel = () => {
  import('slick-carousel').then(() => {
    $('.js-sponsors-feed').slick({
      arrows: true,
      dots: false,
      slidesToShow: 7,
      slidesToScroll: 7,
      autoplay: true,
      autoplaySpeed: 5000,
      prevArrow: `<button type="button" class="slick-prev"><span class="svg-container">${svgs('arrowLeft')}</span></button>`,
      nextArrow: `<button type="button" class="slick-next"><span class="svg-container">${svgs('arrowRight')}</span></button>`,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
            arrows: false,
          },
        },
      ],
    });
  });
}

const teamCarousel = () => {
  $(window).on('load resize orientationchange', () => {
    const $carousel = $('.js-team-carousel');
    if (!$carousel.hasClass('slick-initialized')) {
      import('slick-carousel').then(() => {
        $('.js-team-carousel').slick({
          arrows: false,
          dots: true,
          slidesToShow: 1,
          mobileFirst: true,
          centerMode: true,
          infinite: false,
          responsive: [
            {
              breakpoint: 768,
              settings: 'unslick'
            }
          ]
        });
      });
    }
  });
}

const feedCarousel = () => {
  import('slick-carousel').then(() => {
    $('.js-feed-slider').slick({
      arrows: false,
      dots: false,
      slidesToShow: 3,
      slidesToScroll: 2,
      infinite: false,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  });
}

const aboutCarousel = () => {
  import('slick-carousel').then(() => {
    $('.js-gallery-slider').slick({
      arrows: true,
      dots: false,
      slidesToShow: 1,
      prevArrow: `<button type="button" class="slick-prev"><span class="svg-container">${svgs('chevronLeft')}</span></button>`,
      nextArrow: `<button type="button" class="slick-next"><span class="svg-container">${svgs('chevronRight')}</span></button>`,
    });
  });
}

export { sponsorsCarousel, feedCarousel, teamCarousel, aboutCarousel } ;
